const courses = {
	title: "Kurs",
	longrun_title: "Opplæringsløp",
	new_course: "Nytt kurs",
	new_longrun_course: "Nytt opplæringsløp",
	edit_course: "Rediger kurs: {name}",
	edit_longrun_course: "Rediger opplæringsløp: {name}",
	view_course: "Vis kurs: {name}",
	list_title: "Kurs",
	list_subtitle: "Endre kurs",
	create_title: "Legg til kurs",
	update_title: "Endre kurs",
	address_title: "Addresse",
	details_title: "Kurs detaljer",
	id: "ID",
	name: "Navn",
	short_description: "Praktisk info til påmeldingsskjema",
	description: "Kompetansebeskrivelse ( vises også i påmelding)",
	instructor_id: "Instruktør",
	start_datetime: "Start Dato/Tid",
	start_date: "Start Dato",
	start_time: "Start Tid",
	end_datetime: "Slutt Dato/Tid",
	end_date: "Slutt Dato",
	end_time: "Slutt Tid",
	price: "Pris",
	location: "Lokasjon",
	type: "Kompetansegruppe",
	num_places: "Plasser",
	num_enrolled: "Påmeldte",
	num_enrolled_attendees: "Deltagere",
	send_email_notification: "Epost varsling",
	send_sms_notification: "SMS varsling",
	status: "Status",
	is_published: "Publiser?",
	is_published_helptext: "Kryss av for å gjøre kurs tilgjengelig i kursliste og påmelding for alle",
	created_by: "Opprettet av",
	register_link: "Påmelding",
	number_of_days: "Antall dager",
	upload_image: "Last opp",
	select_image: "Velg bilde",
	upload_document: "Last opp dokument",
	select_document: "Velg fil",
	no_image_selected: "Ingen bilde valgt",
	no_document_selected: "Ingen dokumenter valgt",
	all: "Alle",
	course_popup_title: "Velg kurs for påmelding av {length} elev(er)",
	filter_course: "Kursfilter",
	no_course_selected: "Ingen kurs valgt",
	attendance_list: "Registrer deltagere",
	attendance: "Oppmøte",
	cancel_course: "Kanseller",
	cancelcourse_message: "Vil du kansellere kurs?",
	cancelcourse_success: "Kurs er blitt kansellert",
	show_requests_only: "Vis forespørsler",
	select_requests_only: "Velg fra forespørsler",
	select_students: "Velg fra elever",
	course_list: "Webvisning",
	quick_filter: "Velg",
	course_date_change_notification: "Utførte endringene vil trigge vrasling. Vennligst velg under.",
	attendee_remove_back_enrolment: "Vil du flytte deltager tilbake til påmeldt?",
	attendee_remove: "Deltager vil bli slettet. Vil du fortsette?",
	cant_find_course: "Finner du ikke kurs? Meld din interesse her.",
	delete_enrolment: "Slett påmelding",
	move_enrolment: "Hvor vil du flytte den påmeldte?",
	move_enrolment_interested_list: "Interesseliste",
	move_enrolment_another_course: "Meld på kurs",
	move_enrolment_interested_list_success: "Påmelding er flyttet til interesseliste",
	move_enrolment_interested_list_failed: "Flytting til interesseliste feilet. Feilen er registrert.",
	move_enrolment_another_course_success: "Påmelding er flyttet til annet kurs.",
	move_enrolment_another_course_failed: "Flytting til annet kurs feilet. Feilen er registrert.",
	register_attendance: "Registrer oppmøte",
	register_attendance_helper: "Kryss av hvis du vil registrere  daglig oppmøte.",
	course_dates: "Kurs datoer",
	course_descriptions: "Kurs beskrivelse",
	enrolment_due_date: "Påmeldingsfrist",
	exclude_weekends: "Kun ukedager",
	overbooked_tooltip: "Kurset har for mange påmeldte. Krever handling.",
	allow_overbook: "Tillat overbooking?",
	allow_overbook_helptext: "Når valgt vil påmelding være aktiv selv om kurset er fullt. Påmeldinger vil være synlige i dette kurset og ikke i interesse lsite.",
	allow_reservation: "Tillat plass reservasjon",
	allow_reservation_helptext: "Aktiver for å tillate bedrifter å reservere plasser uten elevinformasjon. Må håndteres manuelt i etterkant.",
	course_documents: "Kurs dokumenter",
	certificate_valid_until: "Bevis er gyldig til",
	certificate_valid_until_helptext: "Beregnet basert på antall måneder satt i kursmal",
	expired: "Utløpt",
	valid_until: "Gyldig til",
	adjust_time_per_day: "Juster tid per dag",
	adjust_time_per_day_confirm: "Endringene gjort for start og slutt tid per dag vil gå tapt. Vil du fortsette?",
	certificate_issued_date: "Utstedt dato",
	date_text_clps: "{day} dag(er) med start {date}",
	organisation: "Opplæringsvirksomhet",
	update_comment: "Endre kommentar",
	comment: "Kommentar",
	stand_in: "Tilleggsinstruktør",
	move_attendee_message: "Velg hva du vil gjøre med deltager",
	delete_attendee: "Slett fra deltagerlista",
	move_attendee_another_course: "Meld på annet kurs",
	move_attendee_interested_list: "Flytt til interesseliste",
	move_attendee_interested_list_success: "Deltager er flyttet til interesselista",
	move_attendee_interested_list_failed: "Flytting av deltager til interesselista feilet.",
	move_attendee_another_course_success: "Deltager er flyttet til annet kurs",
	move_attendee_another_course_failed: "Flytting av deltager til annet kurs feilet.",
	upcoming_course: "Tilgjengelige kurs",
	dates_not_set: "Kursdatoer er ikke valgt",
	move_course_diff_template: "Kursmal for det nye kurset er ikke den samme som i påmelding. Alle tilvalg vil bli fjernet. Vil du fortsette?",
	company_internal: "Bedriftsinterne",
	company_internal_course: "Bedriftsinterne kurs",
	company_internal_select: "Bedriftsinternopplæring. Velg bedrift.",
};
export default courses;